export default "__VITE_ASSET__CJH_9xJH__"